import { useState, useMemo } from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export const useSortableTable = (defaultKey = null, defaultDir = null) => {
  const [sortConfig, setSortConfig] = useState({ key: defaultKey, direction: defaultDir });

  const handleSort = (columnKey) => {
    setSortConfig(prev => {
      if (prev.key === columnKey) {
        if (prev.direction === 'asc') return { key: columnKey, direction: 'desc' };
        if (prev.direction === 'desc') return { key: null, direction: null };
      }
      return { key: columnKey, direction: 'asc' };
    });
  };

  const sortData = (data) => {
    if (!sortConfig.key || !sortConfig.direction) return data;
    return [...data].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1;
      if (bVal == null) return -1;
      let cmp;
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        cmp = aVal - bVal;
      } else {
        cmp = String(aVal).localeCompare(String(bVal), 'el', { numeric: true });
      }
      return sortConfig.direction === 'asc' ? cmp : -cmp;
    });
  };

  return { sortConfig, handleSort, sortData };
};

export const SortIcon = ({ sortConfig, columnKey }) => {
  if (sortConfig.key !== columnKey) return <ArrowUpDown className="h-3 w-3 opacity-40 inline ml-1" />;
  if (sortConfig.direction === 'asc') return <ArrowUp className="h-3 w-3 inline ml-1" />;
  return <ArrowDown className="h-3 w-3 inline ml-1" />;
};

export const SortableTh = ({ children, columnKey, sortConfig, onSort, className = '' }) => (
  <th
    className={`cursor-pointer hover:bg-black/10 select-none transition-colors ${className}`}
    onClick={() => onSort(columnKey)}
    data-testid={`sort-header-${columnKey}`}
  >
    <span className="inline-flex items-center gap-1">
      {children}
      <SortIcon sortConfig={sortConfig} columnKey={columnKey} />
    </span>
  </th>
);
